import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from '../../router'
import {
  HEALTHCHECK, HEALTHCHECK_SUCCESS, HEALTHCHECK_FAILURE, AUTH_ERROR
} from './mutation-types'

Vue.use(VueAxios, axios)

export default {
  state: {
    error: '',
    loading: false,
    maintenance: false
  },
  getters: {
    apiError: state => {
      return state.error
    },
    apiLoading: state => {
      return state.loading
    },
    maintenance: state => {
      return state.maintenance
    }
  },
  actions: {
    apiGet ({commit, state, rootState}, params) {
      // params.loadparamsが'block'指定の場合は全面ブロック
      var commonLoadingElm = null
      commonLoadingElm = document.getElementById('commonAjaxLoading')
      if (commonLoadingElm) {
        commonLoadingElm.style['display'] = 'block'
      }
      params.loadparams = false
      state.loading = params.loadparams
      var url = null
      if (params.url.startsWith('http')) {
        if (rootState.config.api_method === 'https' && !params.url.startsWith('https')) {
          url = params.url.replace('http', rootState.config.api_method)
        } else {
          url = params.url
        }
      } else {
        url = rootState.config.api_method + '://' + rootState.config.api_server + '/' + rootState.config.api_version + params.url
      }
      return axios({method: 'get', url: url, params: params.data, headers: {'Authorization': window.localStorage.getItem('access_token')}})
        .then((response) => {
          if (commonLoadingElm) commonLoadingElm.style['display'] = 'none'
          state.loading = false
          commit(HEALTHCHECK_SUCCESS)
          return Promise.resolve(response)
        })
        .catch((error) => {
          if (commonLoadingElm) commonLoadingElm.style['display'] = 'none'
          state.loading = false
          if (error.response && error.response.status && error.response.status === 401) {
            commit(AUTH_ERROR, error)
            commit(HEALTHCHECK_SUCCESS)
          } else if (error.response && error.response.status && error.response.status === 404) {
            console.log('404 NOT FOUND')
            commit(HEALTHCHECK_SUCCESS)
          } else if (error.response && error.response.status && error.response.status === 500) {
            console.log('500 ERROR')
            commit(HEALTHCHECK_SUCCESS)
          } else if (error) {
            console.log('HEALTHCHECK FAILURE')
            commit(HEALTHCHECK_FAILURE)
          }
          return Promise.reject(error)
        })
    },
    apiPost ({commit, state, rootState}, params) {
      var commonLoadingElm = null
      commonLoadingElm = document.getElementById('commonAjaxLoading')
      if (params.isLoading && commonLoadingElm) {
        commonLoadingElm.style['display'] = 'block'
      }
      state.loading = true
      var url = null
      if (params.url.startsWith('http')) {
        url = params.url
      } else {
        url = rootState.config.api_method + '://' + rootState.config.api_server + '/' + rootState.config.api_version + params.url
      }
      return axios({method: 'post', url: url, data: params.data, headers: {'Authorization': window.localStorage.getItem('access_token')}})
        .then((response) => {
          if (commonLoadingElm) commonLoadingElm.style['display'] = 'none'
          state.loading = false
          return Promise.resolve(response)
        })
        .catch((error) => {
          if (commonLoadingElm) commonLoadingElm.style['display'] = 'none'
          state.loading = false
          if (error.response && error.response.status && error.response.status === 401) {
            commit(AUTH_ERROR, error)
          }
          return Promise.reject(error)
        })
    },
    apiPatch ({commit, state, rootState}, params) {
      // params.loadparamsの指定が無い場合はデフォルト true
      params = Object.assign({}, {'loadparams': true}, params)
      state.loading = params.loadparams
      var url = null
      if (params.url.startsWith('http')) {
        url = params.url
      } else {
        url = rootState.config.api_method + '://' + rootState.config.api_server + '/' + rootState.config.api_version + params.url
      }
      return axios({method: 'patch', url: url, data: params.data, headers: {'Authorization': window.localStorage.getItem('access_token')}})
        .then((response) => {
          state.loading = false
          return Promise.resolve(response)
        })
        .catch((error) => {
          state.loading = false
          if (error.response && error.response.status && error.response.status === 401) {
            commit(AUTH_ERROR, error)
          }
          return Promise.reject(error)
        })
    },
    apiDelete ({commit, state, rootState}, params) {
      state.loading = true
      var url = null
      if (params.url.startsWith('http')) {
        url = params.url
      } else {
        url = rootState.config.api_method + '://' + rootState.config.api_server + '/' + rootState.config.api_version + params.url
      }
      return axios({method: 'delete', url: url, data: params.data, headers: {'Authorization': window.localStorage.getItem('access_token')}})
        .then((response) => {
          state.loading = false
          return Promise.resolve(response)
        })
        .catch((error) => {
          state.loading = false
          if (error.response && error.response.status && error.response.status === 401) {
            commit(AUTH_ERROR, error)
          }
          return Promise.reject(error)
        })
    },
    apiBlobDownload ({commit, state, rootState}, params) {
      state.loading = true
      var url = null
      if (params.url.startsWith('http')) {
        url = params.url
      } else {
        url = rootState.config.api_method + '://' + rootState.config.api_server + '/' + rootState.config.api_version + params.url
      }
      return axios({method: 'get', url: url, params: params.data, headers: {'Authorization': window.localStorage.getItem('access_token')}, responseType: 'blob'})
        .then((response) => {
          state.loading = false
          return Promise.resolve(response)
        })
        .catch((error) => {
          state.loading = false
          if (error.response && error.response.status && error.response.status === 401) {
            commit(AUTH_ERROR, error)
          }
          return Promise.reject(error)
        })
    },
    [HEALTHCHECK] ({dispatch}) {
      dispatch('apiGet', {url: '/healthcheck'})
    }
  },
  mutations: {
    [AUTH_ERROR] (state, error) {
      window.localStorage.removeItem('access_token')
      state.error = error.response.data.error
      router.push('/login')
    },
    [HEALTHCHECK_SUCCESS] (state) {
      state.maintenance = false
    },
    [HEALTHCHECK_FAILURE] (state) {
      state.maintenance = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/api.js